export const LOCKED_ROLE_FOR_CHANGE = [
  'Создатель проекта',
  'Пользователь',
  'Работник'
]